<template>
  <component
    :is="tag"
    class="link"
    :class="classes"
    :href="href"
    @click="handleClick"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: "CustomButtonV3",
  props: {
    tag: {
      type: String,
      default: "a",
      validator(value) {
        return ["a", "button"].includes(value);
      },
    },
    theme: {
      type: String,
      default: "primary",
      validator(value) {
        return ["primary", "primary-light"].includes(value);
      },
    },
    href: {
      type: String,
      default: null,
    },
  },
  emits: ["click"],
  computed: {
    classes() {
      return {
        "link--primary-light": this.theme === "primary-light",
      };
    },
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  color: $color-black;
  @include utility-button(13px);
  position: relative;
  padding-bottom: 5px;
  display: inline-block;
  cursor: pointer;
  text-decoration: none;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    display: block;
    width: 100%;
    height: 1px;
    background-color: $color-black;
  }

  &--primary-light {
    color: $color-white;

    &::after {
      background-color: $color-white;
    }
  }
}
</style>
